import React from "react";
import _ from "lodash";
import clsx from "clsx";

import {withStyles} from "@material-ui/core/styles";

import styles from "./styles";
import {isRequiredQuestion, isValidValue} from "../../../../../utils";
import {ToggleButton} from "@material-ui/lab";
import {FormControl, FormHelperText} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import {FIELD_REQUIRED_MSG} from "../../../../../constants";

function toggleQuestionAnswer(question){
  return {
    question_uid: question.uid,
    answer: [question.answer]
  }
}

function isToggleQuestionValid(question, step, afterChange, service) {
  let isValid = true
  if (isRequiredQuestion(question)) {
    if (!isValidValue(question.answer)) {
      isValid = false
      question.error = FIELD_REQUIRED_MSG
    } else {
      question.error = null
    }
  }

  return isValid;
}

function initToggleQuestionAnswer(question, answer){
  if (answer && answer.length > 0) {
    question.answer = answer[0];
  } else {
    question.answer = null;
  }
}

export const ToggleQuestionMethods = {
  required: isRequiredQuestion,
  valid: isToggleQuestionValid,
  answer: toggleQuestionAnswer,
  initAnswer: initToggleQuestionAnswer,
}

export const ToggleFormElement = withStyles(styles)(props => {

  const {
    classes,
    required,
    disabled,
    error,
    label,
    customClasses,
    handleChange,
    value,
    uid,
  } = props;

  const switchPositionsClass = React.useMemo(() => {
    switch (value) {
      case true:
        return classes.sliderOn;
      case false:
        return classes.sliderOff;
      default:
        return classes.sliderNull;
    }
  }, [value]);

  return (
    <div className={classes.container}>
      <FormControl>
        <InputLabel
          htmlFor={uid}
          required={required}
          disabled={disabled}
          error={error}
          classes={{
            root: clsx(classes.labelRoot, customClasses.labelRoot),
            error: classes.error,
            asterisk: classes.labelAsterisk
          }}
        >
          {label}
        </InputLabel>
        <div id={uid} className={clsx(classes.toggleSwitch, customClasses.toggleSwitch, value && classes.active)}>
          <span className={clsx(classes.slider, customClasses.slider, switchPositionsClass)} />
          <ToggleButton disabled={disabled} className={clsx(classes.switch, customClasses.switch)} value={value} onChange={handleChange}/>
        </div>
        <FormHelperText className={error && classes.error} error={error} >{error}</FormHelperText>
      </FormControl>
    </div>
  );
});

const ToggleQuestion = props => {
  const {
    question,
    onAnswerChange,
  } = props;

  React.useEffect(() => {
    if(_.isNil(question.answer)){
      initToggleQuestionAnswer(question)
    }
}, []);

  const label = question.question_text || '';
  const customClasses = question.custom_classes || {};
  const required = ToggleQuestionMethods.required(question);
  const disabled = !!question.disabled;
  const answer = question.answer;

  const handleChange = () => {
    question.error = null;
    onAnswerChange(question.uid, !question.answer);
  };

  return (
    <ToggleFormElement
      uid={question.uid}
      value={answer}
      required={required}
      disabled={disabled}
      customClasses={customClasses}
      label={label}
      handleChange={handleChange}
      error={question.error}
    />
  )
};

export default ToggleQuestion;